<template>
  <b-modal
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    :title="title"
    footer-class="removed"
    class="edit-modal"
    id="activityModal"
    no-close-on-backdrop
  >
    <b-card-text>
      <validation-observer ref="activityValidation">
        <b-form @submit.prevent="saveActivity">
          <b-row>
            <!-- <b-col cols="12">
              <b-form-checkbox
                @change="onUrgentChecked"
                class="inline custom-control-primary my-1"
              >
                <span> نشاط طارئ </span>
              </b-form-checkbox>
            </b-col> -->
            <b-col cols="12">
              <!-- <form-select
                v-if="!intializeForm.activity_id && program_id !== 0"
                label="البرنامج"
                v-model="program_id"
                :getOptionLabel="(x) => x.name"
                :reduce="(x) => x.id"
                id="programs"
                ep="v2/selects/programs"
                rules="required"
                ref="programs"
              /> -->
              <form-select
                v-if="!intializeForm.activity_id && program_id !== 0"
                
                rules="required"
                label="البرنامج"
                id="program"
                v-model="program_id"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name"
                ep="/v2/selects/programs"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                v-if="!intializeForm.activity_id"
                label="النشاط"
                v-model="form.activity_id"
                :getOptionLabel="(x) => x.name"
                :reduce="(x) => x.id"
                id="activity"
                :ep="activitiesEp"
                rules="required"
                ref="activity"
              />
              <form-input
                v-else
                plaintext
                id="act"
                label="النشاط"
                :value="activityName"
              />
            </b-col>
            <b-col cols="12">
              <b-form-group class="checkbox-cont" label="التنفيذ">
                <b-form-checkbox-group
                  id="checkbox-group"
                  v-model="form.months"
                  :options="options"
                  name="flavour-1"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <form-input
                id="beneficiaries_number"
                label="عدد المستفيدين"
                v-model.number="form.beneficiaries_number"
                rules="required"
              />
            </b-col>
            <b-col cols="12">
              <form-input
                id="funds"
                label="الموازنة"
                v-model.number="form.funds"
                rules="required"
              />
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="primary"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-text>
  </b-modal>
</template>

<script>
import { required } from "@validations";
import { ValidationObserver } from "vee-validate";

import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BFormCheckbox,
  BFormCheckboxGroup,
  BButton,
} from "bootstrap-vue";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
const initForm = {
  activity_id: null,
  funds: null,
  beneficiaries_number: null,
  months: [],
};

export default {
  components: {
    ValidationObserver,
    formInput,
    formSelect,
    BButton,
    formDatepicker,
    saveBtn,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BForm,
    BFormRadio,
    BFormTextarea,
    BFormCheckbox,
    BFormCheckboxGroup,
  },
  props: {
    value: Boolean,
    title: { type: String, default: () => "تفاصيل النشاط" },
    btnLabel: { type: String, default: () => "حفظ" },
    loading: Boolean,
    activityName: {
      type: String,
      default: () => null,
    },
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      program_id: 0,
      selected: [],
      options: [
        { text: "ك 2", value: "1" },
        { text: "شباط", value: "2" },
        { text: "آذار", value: "3" },
        { text: "نيسان", value: "4" },
        { text: "أيار", value: "5" },
        { text: "حزيران", value: "6" },
        { text: "تموز", value: "7" },
        { text: "آب", value: "8" },
        { text: "أيلول", value: "9" },
        { text: "ت 1", value: "10" },
        { text: "ت 2", value: "11" },
        { text: "ك 1", value: "12" },
      ],
      required,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    activitiesEp() {
      return this.program_id || this.program_id === 0
        ? "v2/selects/activities/" + this.program_id
        : "v";
    },
  },
  watch: {
    modalOpen(val) {
      if (val) this.init(this.intializeForm);
    },
    activitiesEp(newVal) {
      if (this.$refs.activity && this.activitiesEp.length > 1)
        this.$refs.activity.refreshOptions(newVal);
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    onUrgentChecked(val) {
      if (val) this.program_id = 0;
      else this.program_id = null;
    },
    saveActivity() {
      this.$refs.activityValidation.validate().then((success) => {
        if (success) {
          this.form.program_id = this.program_id
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.checkbox-cont {
  .bv-no-focus-ring {
    display: grid;
    grid-template-columns: auto auto auto auto;
  }
}
</style>
